(() => {
  const shopMenu = document.getElementById("HeaderMenu-shop")?.closest("details");
  if (!shopMenu) return;

  const seriesLinks = shopMenu.querySelectorAll(":scope > ul.header__submenu > li > a[href]");
  let hoverTimer;

  seriesLinks.forEach((link) => {
    link.addEventListener("pointerenter", (event) => {
      if (event.pointerType !== "mouse") return;

      window.clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(() => {
        if (link.matches(":hover")) window.location.assign(link.href);
      }, 280);
    });

    link.addEventListener("pointerleave", () => window.clearTimeout(hoverTimer));
    link.addEventListener("pointercancel", () => window.clearTimeout(hoverTimer));
  });
})();